import React, { useState, useEffect } from 'react'
import './landing.css'

function INCSUBLanding() {

  /**
 * @constant windowWidth
 * @author Vishal Lohbande
 * @description Tracks the current width of the browser window and updates the state 
 * in real-time when the window is resized. Sets up an event listener for `resize` 
 * on component mount and removes it on unmount to avoid memory leaks.
 * 
 * The `windowWidth` value can be used to create responsive UI behavior by checking
 * for breakpoints and rendering different layouts accordingly.
 * 
 * @returns {number} Current width of the browser window in pixels.
 * 
 * Usage:
 * Use this logic inside a component or extract it as a custom hook to adapt UI
 * based on screen size (e.g., mobile vs desktop).
 */
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  return (
    <div className='INCSUBHome_ctn'>
      <div className='INCSUBHome_ctn_top_ctn'>
        <div className='INCSUBHome_ctn_top_paragraph_text'>
          <div className='INCSUBHome_ctn_top_paragraph_text_flex_end'>
            <div className='INCSUBHome_ctn_top_paragraph_tagline'>
              <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.50112 0.0373332C7.42656 0.0608405 7.29367 0.141985 7.2058 0.217722C7.07138 0.333647 0.265188 9.78571 0.0652919 10.1341C-0.0219211 10.2861 -0.0217159 10.6727 0.0656204 10.8252C0.149711 10.972 0.32804 11.1392 0.487924 11.221C0.599292 11.2781 0.889277 11.2856 3.31304 11.2952C4.79862 11.3011 6.01406 11.3199 6.01406 11.3371C6.01406 11.3542 5.86626 12.635 5.68563 14.1833C5.505 15.7316 5.35711 17.0835 5.35699 17.1876C5.3562 17.887 6.24538 18.2608 6.79109 17.7905C6.92789 17.6726 13.7273 8.23135 13.9344 7.87161C14.0219 7.71976 14.0218 7.33329 13.9343 7.18055C13.8503 7.03375 13.6719 6.86659 13.512 6.78472C13.4007 6.7277 13.1107 6.7201 10.6869 6.71052C9.20134 6.70469 7.98591 6.6862 7.98591 6.66952C7.98591 6.6528 8.13511 5.35473 8.31751 3.78492C8.4999 2.21507 8.64159 0.839456 8.63239 0.727979C8.59217 0.240884 8.00103 -0.120008 7.50112 0.0373332Z" fill="#E09710" />
              </svg>
              {'Its time to go TheSubscription way'}</div>
            {windowWidth > 620 ? (
              <div className='INCSUBHome_ctn_top_paragraph_heading'>
                <p className='INCSUBHome_ctn_top_paragraph_heading_para'>
                  {'One stop solution'}
                </p>
                <p className='INCSUBHome_ctn_top_paragraph_heading_para'>{'for all Your'}</p>
                <p className='INCSUBHome_ctn_top_paragraph_heading_para'><span>{'Subscription'}</span></p>
                <p className='INCSUBHome_ctn_top_paragraph_heading_para'>{'Needs.'}</p>
              </div>
            ) :

              (
                <div className='INCSUBHome_ctn_top_paragraph_heading'>
                  <p className='INCSUBHome_ctn_top_paragraph_heading_para'>
                    {'One stop'}
                  </p>
                  <p className='INCSUBHome_ctn_top_paragraph_heading_para'>{'solution for all '}</p>
                  <p className='INCSUBHome_ctn_top_paragraph_heading_para'>Your <span>{'subscription'}</span></p>
                  <p className='INCSUBHome_ctn_top_paragraph_heading_para'>{'Needs.'}</p>
                </div>
              )
            }

            <div className='INCSUBHome_ctn_top_paragraph_desc'><p>{'A subscription management platform that allows you to share subscriptions efficiently with friends and family.'}</p></div>
            <div className='INCSUBHome_ctn_top_paragraph_btns'>
              <a style={{ textDecoration: 'none' }} href='https://play.google.com/store/apps/details?id=com.incubators.subscription' target='_blank'>
                <img src='/assets/images/googlePlayStoreIcon.png' alt='googlePlayStoreIcon' />
              </a>
              <a style={{ textDecoration: 'none' }} href='https://apps.apple.com/in/app/the-subscription/id6747078162' target='_blank'>
                <img src='/assets/images/AppStore.png' alt='AppStoreIcon' />
              </a>
            </div>
          </div>
        </div>
        <div className='INCSUBHome_ctn_top_image_ctn'>
          <img src='/assets/images/homemobile.png' alt='homemobile-img' />
        </div>
      </div>
    </div>
  )
}

export default INCSUBLanding;
